import { Injectable } from '@angular/core';
import { JeevesOrderDetailsConfigService, JeevesAddOrderRowModalComponent } from 'gung-standard-jeeves';
import { Order } from 'gung-standard';
import { CultAddOrderRowModalComponent } from '../components/cult-add-order-row-modal/cult-add-order-row-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CultOrderDetailsConfigService extends JeevesOrderDetailsConfigService {
  isOrderEditable(order: Order, isSales: boolean) {
    return order.extra.oh.ordstat <= 10 && isSales;
  }
  openAddOrderRowModal(order: Order) {
    const modalRef = this.modalService.open(CultAddOrderRowModalComponent, {
      size: 'lg',
      backdrop: 'static'
    });
    modalRef.componentInstance.order = order;
  }
}
